import React, { useState, useEffect } from 'react';
import PageTitle from '../shared/PageTitle';
import { noticeAPI } from '../../services/api';
import '../../styles/GuardTheme.css';

const GuardAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await noticeAPI.getAnnouncements();
        setAnnouncements(response.data);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError('Failed to load announcements.');
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, []);

  // const isAnnouncementActive = (announcement) => {
  //   const now = new Date();
  //   const startDate = new Date(announcement.start_date);
  //   const expiryDate = announcement.expiry_date ? new Date(announcement.expiry_date) : null;
    
  //   return startDate <= now && (!expiryDate || expiryDate >= now);
  // };

  // const getAnnouncementStatus = (announcement) => {
  //   const now = new Date();
  //   const startDate = new Date(announcement.start_date);
  //   const expiryDate = announcement.expiry_date ? new Date(announcement.expiry_date) : null;
    
  //   if (startDate > now) {
  //     return { status: 'upcoming', badge: 'bg-warning', text: 'Upcoming' };
  //   } else if (expiryDate && expiryDate < now) {
  //     return { status: 'expired', badge: 'bg-secondary', text: 'Expired' };
  //   } else {
  //     return { status: 'active', badge: 'bg-success', text: 'Active' };
  //   }
  // };

  if (loading) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-bullhorn" title="Society Announcements" />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-bullhorn" title="Society Announcements" />
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  // const activeAnnouncements = announcements.filter(isAnnouncementActive);
  // const inactiveAnnouncements = announcements.filter(ann => !isAnnouncementActive(ann));

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle icon="fa-bullhorn" title="Society Announcements" />
      
      {announcements.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          No announcements available at this time.
        </div>
      ) : (
        <div className="row">
          {announcements.map((ann, index) => (
            <div key={ann.id} className="col-lg-6 col-xl-4 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-header bg-primary text-white">
                  <div className="d-flex align-items-center">
                    <div className="badge bg-warning text-dark me-3 fw-bold">
                      {index + 1}
                    </div>
                    <h6 className="mb-0">{ann.title}</h6>
                  </div>
                </div>
                <div className="card-body">
                  <p className="card-text">{ann.description}</p>
                  <div className="mt-3">
                    <small className="text-muted">
                      <i className="fas fa-calendar-alt me-2"></i>
                      {new Date(ann.start_date).toLocaleDateString()}
                      {ann.expiry_date && (
                        <span> - {new Date(ann.expiry_date).toLocaleDateString()}</span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GuardAnnouncements; 